export default "__VITE_ASSET__OJLwRtE8__"